// extracted by mini-css-extract-plugin
export default {"user-cell":"user-cell_user-cell__wFimE","user-cell__user-info":"user-cell_user-cell__user-info__PeiRQ"};